"use client";

import { use } from "react";
import Image from "next/image";
import IconStarGray from "@/components/Icon/IconStarGray.svg";
import IconStarGold from "@/components/Icon/IconStarGold.svg";
import IconStar from "@/components/Icon/IconStar.svg";
import ProductReviews from "@/components/ProductDetails/ProductReviews";
import { calculateReviewBarWidth } from "@/utils/common";
import { ProductDetailSchema } from "@/markup/schema/ProductDetail";

export default function Reviews({ product, reviewsPromise }) {
  const reviewsData = use(reviewsPromise);
  const summaryReiews = reviewsData;
  return (
    <>
      <script
        id="ProductDetailSchema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `${ProductDetailSchema(product, reviewsData, summaryReiews)}`,
        }}
      />
      <div className="flex flex-wrap pb-6">
        <div className="w-full md:w-3/12 mb-5">
          <p className="font-bold">Average Rating</p>
          <h1>{summaryReiews.total > 0 ? summaryReiews.rating.toFixed(1) : "0.0"}</h1>
          <div className="flex gap-1">
            {[...Array(5)].map((_, index) =>
              index < summaryReiews.rating ? (
                <Image key={`review-star-${index}`} src={IconStarGold.src} alt="" width={14} height={14} />
              ) : (
                <Image key={`review-star-${index}`} src={IconStarGray.src} alt="" width={14} height={14} />
              )
            )}
          </div>
          <span className="text-xs">Based on {summaryReiews.total || 0} reviews</span>
        </div>
        <div className="w-full md:w-9/12">
          <p className="font-bold">Reviews</p>
          <div className="w-[287px] flex flex-wrap gap-1">
            {[5, 4, 3, 2, 1].map(rating => (
              <div key={`rating-${rating}`} className="w-full flex justify-between items-center">
                <div className="flex items-center gap-[3px]">
                  {rating}
                  <Image src={IconStar.src} alt="" width={8} height={8} className="text-black w-2 h-2" />
                </div>
                <div className="w-[222px] h-2 rounded-[10px] bg-grey-200">
                  {summaryReiews.breakdown ? (
                    <div
                      className="w-[100px] h-2 rounded-[10px] bg-gold"
                      style={{
                        width: calculateReviewBarWidth(
                          summaryReiews.breakdown[`rating${rating}`],
                          summaryReiews.total,
                          222
                        ),
                      }}
                    ></div>
                  ) : (
                    <div className="w-[100px] h-2 rounded-[10px] bg-gold" style={{ width: 0 }}></div>
                  )}
                </div>
                {summaryReiews.breakdown && <span>({summaryReiews.breakdown[`rating${rating}`]})</span>}
              </div>
            ))}
          </div>
        </div>
      </div>
      <ProductReviews productId={product?.primaryId} reviewsData={reviewsData} summaryReiews={summaryReiews} />
    </>
  );
}
